import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { InsuranceProductType } from '../../api/types';

const useStaticInsuranceProductType = (countryCode?: string) => {
    const { t } = useTranslation(['insuranceProductDetails']);

    return useMemo(() => {
        const insuranceProductTypeOptions = [
            {
                key: InsuranceProductType.Eazy,
                title: t('insuranceProductDetails:transferFields.eazy'),
            },
        ];

        return { insuranceProductTypeOptions };
    }, [countryCode, t]);
};

export default useStaticInsuranceProductType;
